// Utils
import apiClient from "@/utils/global/apiClient";

export interface UserInstance {
  instance_id: string;
  instance_name: string;
}

export const getUserInstances = async (): Promise<UserInstance[] | null> => {
  try {
    const response = await apiClient.get("/settings/user/me");

    if (!Array.isArray(response.data) || response.data.length === 0) {
      console.warn("Expected an array response but got:", response.data);
      return null;
    }

    const instances = response.data.map((item: any) => ({
      instance_id: item.instance_id,
      instance_name: item.instance_name,
    }));

    return instances;
  } catch (error) {
    console.error("Error fetching user instances:", error);
    return null;
  }
};


export type AuditScoreApiItem = {
  field_audit_id: number;
  field_vendor: string; // e.g. "META" | "INSTAGRAM"
  score: number;        // 0–1
  status: string;       // e.g. "SUCCESS"
  name: string;         // Field.audit_title
  pillar: string;       // Field.audit_pillar
  description: string;  // Field.audit_description
};

export const fetchAuditScores = async (
  instanceId: string,
  group?: string,
  startDate?: string, // "YYYY-MM-DD"
  endDate?: string    // "YYYY-MM-DD"
): Promise<AuditScoreApiItem[] | null> => {
  try {
    const params = new URLSearchParams();

    if (group) params.append("group", group);
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const queryString = params.toString() ? `?${params.toString()}` : "";
    const url = `/api/v1/core/audit/score/${instanceId}${queryString}`;

    const { data } = await apiClient.get<AuditScoreApiItem[]>(url);
    return data;

  } catch (error) {
    console.error("Error fetching audit scores:", error);
    return null;
  }
};